import { useAppContext } from '../context/AppContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faCircleXmark } from '@fortawesome/free-solid-svg-icons';

const ICONS = {
  success: <FontAwesomeIcon icon={faCircleCheck} aria-hidden="true" />,
  error: <FontAwesomeIcon icon={faCircleXmark} aria-hidden="true" />,
};

export default function StatusToast() {
  const { statusToast, dismissStatus } = useAppContext();

  if (!statusToast) return null;

  return (
    <div
      key={statusToast.id}
      className={`status-toast status-toast--${statusToast.type}`}
      role="status"
      aria-live="polite"
      onAnimationEnd={dismissStatus}
    >
      <span className="status-toast__icon">{ICONS[statusToast.type]}</span>
      <span className="status-toast__message">{statusToast.message}</span>
    </div>
  );
}
